import React from 'react'

function Loader(props) {
    return (
        <div className={`w-full flex justify-center sticky top-0 ${props.isLoaderTop ? " items-start  h-max " : " items-center  h-screen "}`}>
            {/* <div className="loader"></div> */}
            <div className="w-12 h-12 rounded-full animate-spin
                    border-x-4 border-solid border-green-500 border-t-transparent"></div>
        </div>
    )
}

export default Loader